import React from 'react'

function Profile() {
  return (
    <div class="center">
      <img class="inline-block rounded-full max-w-60" src={require('../../assets/Profile.jpg')} alt="Profile"/>
    </div>
  )
}

export default Profile